<template>
	<div class="promotional-tools">

		<template v-if="heroBanner">
			<customisable-banner
				:options="heroBanner"
				:page="promotionalTools"
			>
				<div class="promotional-tools__reg-btn-wrap">
					<btn
						class="promotional-tools__reg-btn btn--style--fill--white fc-pal--blue btn--shape--h48"
						@click="heroRegisterInterest"
					>Request a Demo</btn>
				</div>
			</customisable-banner>
		</template>

		<div class="panel panel--lightest-grey promotional-tools__modules">
			<div class="page-container">
				<div class="tabs">
					<div class="grid grid--g108--desk grid--s48">

						<!-- Tab List -->
						<div class="grid__item one-third--not-phab">
							<div class="tabs__tab-items">
								<ul class="grid grid--s16">
									<li v-for="(tab, index) in tabs" class="grid__item">
										<div
											class="tabs__tab-item"
											:class="{
											'tabs__tab-item--active': activeTab == tab.slug
										}"
											@click="setActiveTab(tab)"
										>
											<div class="grid grid--g12 grid--s0 grid--auto grid--nowrap grid--middle">
												<div class="grid__item">
													<span class="tabs__tab-item-icon fonticon" :class="tab.icon"></span>
												</div>
												<div class="grid__item grid__item--space">
													<span class="tabs__tab-item-text">{{tab.name}}</span>
												</div>
												<div class="grid__item">
													<span class="tabs__tab-item-arrow fonticon fonticon--chevron--right"></span>
												</div>
											</div>
										</div>
									</li>
									<li class="grid__item">
										<div
											class="promotional-tools__register-cta link--action"
											@click="navRegisterInterest"
										>
											<div
												class="promotional-tools__register-cta-text link link--colored link--arrow link--wrap"
											>Register your Interest</div>
										</div>
									</li>
								</ul>
							</div>
						</div>

						<!-- Tab container -->
						<div class="grid__item two-thirds--not-phab">
							<div ref="tabs" class="tabs__contents">
								<div class="tabs__content">

									<h2 class="h2">{{ activeName }}</h2>

									<div v-for="(content, index) in this.moduleContent" :key="index + '-content'" :class="">
										<template v-if="content.type === 'text_image' && content.tab === activeTab">
											<div class="promotional-tools__section">
												<text-image :title="content.title" :text="content.text" :image="content.image" />
											</div>
										</template>
										<template v-if="content.type === 'downloads' && content.tab === activeTab">
											<div class="promotional-tools__section">
												<document-downloads
													:download-links="content.downloadLinks"
													:text="content.text"
												/>
											</div>
										</template>
										<template v-if="content.type === 'carousel' && content.tab === activeTab">
											<div class="promotional-tools__section">
												<h3 v-if="content.title" class="h3 fc-pal--grey">{{ content.title }}</h3>
												<carousel
													class="promotional-tools__carousel"
													:images="sanitizeVideoCarouselContent(content.videos)"
												></carousel>
											</div>
										</template>
										<template v-if="content.type === 'download_image' && content.tab === activeTab">

											<!-- DOWNLOAD -->
											<div class="news-single__download">
												<div
													class="news-single__download__image"
													:style="`background-image:url('${content.image.link}')`"
												/>
												<div class="news-single__download__meta">
													<h2
														v-if="content.title"
														class="news-single__download__title"
													>{{ content.title }}</h2>
													<a :href="content.url" class="link--action link--arrow link--colored" target="_blank">Download</a>
												</div>
											</div>
										</template>
										<template v-if="content.type === 'video' && content.tab === activeTab">
											<div
												class="wistia_responsive_padding promotional-tools__section"
												style="padding: 56.25% 0 0 0; position: relative;"
											>
												<div
													class="wistia_responsive_wrapper"
													style="height: 100%; left: 0; position: absolute; top: 0; width: 100%;"
												>
													<div
														:class="'seo=false videoFoam=true autoPlay=false wistia_embed wistia_async_' + content.videoId"
														style="height: 100%; width: 100%;"
													/>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>


		<!--<template v-if="footerBlocks">
			<feature-icons :item-icons="footerBlocks" />
		</template>-->


		<div ref="register">
			<banner
				v-if="footerBanner"
				class="promotional-tools__banner promotional-tools__banner--footer"
				:backgrounds="footerBackgrounds"
			>
				<div class="h2 promotional-tools__banner-title">

					<template v-if="$root.$data.user">
						{{$root.$data.user.firstName}}, are you ready for next-level player engagement{{$root.$data.user.userType === 'igt' ? '' : ' for ' + $root.$data.user.operator.name }}?
					</template>
					<template v-else>
						Are you ready for next-level player engagement?
					</template>

				</div>
				<div class="promotional-tools__banner-description" v-html="footerBanner.description"></div>
				<form class="promotional-tools__banner-form promotional-tools__sign-up" action="submit">
					<div class="grid grid--g16 grid--s16 grid--auto--not-phab grid--nowrap--not-phab grid--middle grid--center">
						<div class="grid__item">
							<a class="btn btn--shape--h48 promotional-tools__sign-up-submit" href="mailto:peter.nikashin@igt.com?subject=Promotional tools interest" @click="footerRegisterInterest">CONTACT US</a>
						</div>
					</div>
				</form>
			</banner>
		</div>
	</div>
</template>

<script>
import { map, find, includes, cloneDeep } from "lodash";
import TextImage from "./organisms/TextImage";
import Btn from "./atoms/Btn";
import TextField from "./atoms/TextField";
import Banner from "./molecules/Banner";
import Carousel from "./organisms/Carousel";
import CustomisableBanner from "./organisms/CustomisableBanner";
import DocumentDownloads from "./organisms/DocumentDownloads";
import FeatureIcons from "./organisms/FeatureIcons";

export default {
	name: "PromotionalTools",
	components: {
		Btn,
		TextField,
		Banner,
		Carousel,
		TextImage,
		DocumentDownloads,
		CustomisableBanner,
		FeatureIcons
	},
	data() {
		return {
			activeTab: "player_hub",
			tabs: [
				{
					slug: "player_hub",
					name: "Player Hub",
					icon: "fonticon--pt--free-play",
				},
				{
					slug: "prize_engine",
					name: "Prize Engine",
					icon: "fonticon--pt--cash-play",
				},
				{
					slug: "leader_boards",
					name: "Leaderboards",
					icon: "fonticon--pt--prize-pool",
				},
				{
					slug: "award_quests",
					name: "Award Quests",
					icon: "fonticon--pt--prize-pool",
				},
				{
					slug: "prize_draw",
					name: "Prize Draw",
					icon: "fonticon--pt--prize-pool",
				},
				{
					slug: "free_rounds",
					name: "Free Rounds",
					icon: "fonticon--pt--prize-pool",
				}
				// {
				// 	slug: "prize_battle",
				// 	name: "Prize Battle",
				// 	icon: "fonticon--pt--prize-battle",
				// }
			],
			moduleContent: [],
			content: [],
		};
	},
	computed: {
		activeSections: function() {
			return this.activeTab ? find(this.tabs, { slug: this.activeTab }).indices : null;
		},
		activeName: function() {
			return this.activeTab ? find(this.tabs, { slug: this.activeTab }).name : null;
		},
		heroBanner: function()
		{
			return find(this.content, {identifier: 'intro'});
		},
		promotionalTools: function()
		{
			return 'PromotionalTools'
		},
		footerBanner: function()
		{
			return find(this.content, {identifier: 'footer'});
		},
		footerBlocks: function()
		{
			var footerBlocks = find(this.moduleContent, {type: 'footer_blocks'});
			return footerBlocks ? footerBlocks.footer_blocks : null;
		},
		footerBackgrounds: function()
		{
			var self = this;
			var bgs = {};

			if (!this.footerBanner || !this.footerBanner.mobileBackgroundImage || !this.footerBanner.desktopBackgroundImage) return;

			bgs["mob"] = typeof this.footerBanner.mobileBackgroundImage == 'string' ? this.footerBanner.mobileBackgroundImage : this.footerBanner.mobileBackgroundImage.link;
			bgs["ptab"] = bgs["mob"];

			bgs["ltab"] = typeof this.footerBanner.desktopBackgroundImage == 'string' ? this.footerBanner.desktopBackgroundImage : this.footerBanner.desktopBackgroundImage.link;
			bgs["desk"] = bgs["ltab"];

			return bgs;
		}
	},
	mounted: function() {
		let scriptTwo = document.createElement('script')
		scriptTwo.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js')
		document.head.appendChild(scriptTwo)
	},
	async created() {
		this.$root.$data.appLoading = false;
		var self = this;
		await self.applyPromotionalToolsData();
	},
	methods: {
		isSectionActive: function(index) {
			if (!this.activeSections) {
				return true;
			}
			return includes(this.activeSections, index);
		},
		getAssetImage (download) {
			const { iconOverride } = JSON.parse(download)
			return iconOverride || '/static/img/asset-fallback.jpg'
		},
		setActiveTab: function(tab)
		{
			this.activeTab=tab.slug;

			this.trackEvent([
				'promotional-tools-nav-clicked',
				tab.slug,
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);

			this.$scrollTo(this.$refs.tabs, 500, {
				offset: -80
			});
		},

		navRegisterInterest: function()
		{
			this.trackEvent([
				'promotional-tools-nav-clicked',
				'register-interest',
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);

			this.$scrollTo(this.$refs.register, 500, {
				offset: -80
			});
		},
		heroRegisterInterest: function()
		{
			this.trackEvent([
				'promotional-tools-banner-clicked',
				'hero-register-interest',
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);

			this.$scrollTo(this.$refs.register, 500, {
				offset: -80
			});
		},
		footerRegisterInterest: function()
		{
			this.trackEvent([
				'promotional-tools-banner-clicked',
				'footer-register-interest',
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);
		},

		async applyPromotionalToolsData() {
			var self = this;
			var result = await self.$api.getPromotionalToolsPage();
			self.cleanContentData(result.data.content);
			self.cleanPromotionalToolsData(result.data.modules);
		},
		cleanContentData(contentData)
		{
			this.content = cloneDeep(contentData);
		},
		cleanPromotionalToolsData(moduleData)
		{
			this.moduleContent = cloneDeep(moduleData);
		},
		sanitizeVideoCarouselContent(videoData)
		{
			return map(videoData, data => {
				return {
					src: data.image.link,
					description: data.image.metadata,
					videoId: data.video.data
				}
			});
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "src/scss/toolkit";

$c: ".promotional-tools";
#{$c}
{

	.customisable-banner
	{
		&__description
		{
			@include media(not-phab)
			{
				max-width: none;
			}
		}
	}


	// Banner --------
	&__banner {
		min-height: 525px;
		@include media(not-phab) {
			min-height: 700px;
		}

		&-content {
			max-width: 536px;
		}

		&-title {
			@include extend(h2);
			margin-bottom: rem(8);

			@include media(not-phab) {
				@include extend(h1);
				margin-bottom: rem(24);

				@include breakpoint($slim) {
					font-size: rem(40);
				}
			}
		}

		&-description {
			color: palette(light-grey);
			max-width: 416px;
			line-height: 24px;

			@include media(not-phab) {
				@include breakpoint($slim) {
					font-size: 14px;
				}
			}
		}

		&-btn,
		&-form {
			@include media(not-phab) {
				margin-top: rem(56);

				@include breakpoint($slim) {
					margin-top: rem(24);
				}
			}

			@include media(phab) {
				margin-top: rem(24);
			}
		}

		&-form {
			@include media(phab) {
				@include extend(block-center);
				max-width: 320px;
			}
		}

		&-btn {
			min-width: 156px;
		}

		&--footer {
			min-height: 476px;
			text-align: center;

			#{$c}__banner {
				&-title {
					max-width: 782px;
					@include extend(block-center);
					font-size: rem(48);
				}
				&-description {
					max-width: 648px;
					@include extend(block-center);
					color: palette(white);
				}
			}
		}
	}

	// Register Box

	&__reg {
		&-box {
			max-width: 416px;
			@include extend(block-center);
			@include extend(bgc-pal--blue);
			text-align: center;
			padding-top: 1px;
			padding-bottom: rem(52);
		}

		&-avatar {
			width: 98px;
			height: 98px;
			border-radius: 50%;
			border: 4px solid;
			overflow: hidden;
			margin-top: -48px;
			margin-bottom: rem(24);
			@include extend(block-center);
			background-color: palette(light-grey);
			@include extend(bg-fill);
		}

		&-title {
			margin-bottom: rem(24);
		}

		&-description {
			padding: {
				left: rem(40);
				right: rem(40);
			}
			margin-bottom: rem(24);
		}

		&-btn-wrap {
		}
	}

	// Intro ------
	&__intro {
		color: palette(grey);
		padding-top: rem(88);
		padding-bottom: rem(88);

		&-wrap {
			max-width: 764px;
		}

		&-body {
			line-height: 2;
		}
	}

	// Module block
	&__modules {
		padding-top: rem(64);
		padding-bottom: rem(60);
	}

	// Sections ------
	&__section {
		margin-bottom: rem(64);
	}

	// Register CTA ------
	&__register-cta {
		min-height: rem(72);
		@include extend(vertical-center);
		text-align: center;
		border-radius: rem(4);
		padding: rem(20);
		background-color: transparentize(palette(blue, base, false), 0.94);
	}

	// Carousel ------
	&__carousel {
		&-icon {
			position: absolute;
			width: rem(56);
			left: rem(24);
			bottom: rem(24);
			cursor: pointer;
		}

		.carousel {
			&__item {
				width: 415px;
				max-width: 90%;
				padding-right: rem(48);
			}

			&__image {
				&-wrap {
					position: relative;
				}

				&-description {
					color: palette(grey);
					@include extend(heading--bold);
				}
			}

			&__slider {
				display: none;
			}
		}
	}


	// Sign-up ------
	&__sign-up {
		&-input {
			max-width: 100%;

			@include media(phab) {
				width: 100%;
			}

			@include media(not-phab) {
				width: 332px;
			}

			.#{$field-class} {
				&__element-wrap,
				&__element {
					border-radius: 9999px;
				}
			}
		}

		&-submit {
			min-width: 184px;
		}
	}
}

.tabs {
	&__tab-item {
		box-shadow: 0px rem(4) rem(12) rgba(0, 0, 0, 0.08);
		background-color: white;
		border-radius: rem(4);
		padding: rem(20);
		cursor: pointer;

		&:hover {
			background-color: transparentize(palette(blue, base, false), 0.94);
		}

		&--active {
			&,
			&:hover {
				background-color: palette(blue);
				color: palette(white);

				.tabs__tab-item-arrow {
					color: inherit;
					opacity: 1;
				}
			}
		}

		&-icon {
			font-size: rem(32);
		}

		&-text {
			font-size: rem(20);
			@include extend(heading--bold);
		}

		&-arrow {
			font-size: 14px;
			color: palette(grey);
			opacity: 0.25;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/PromotionalTools.vue